<template>
	<div class="ip-overview container">
		<section class="page-hero">
			<div>
				<p class="eyebrow">ACCESS CONTROL</p>
				<h2>IP 与黑名单</h2>
				<p>查看访问来源，并快速处置可疑 IP；所有变更会即时同步至拦截策略。</p>
			</div>
			<div class="hero-icon"><i class="el-icon-shield" /></div>
		</section>

		<el-card class="content-card" shadow="never">
			<el-tabs v-model="activeTab" class="ip-tabs">
				<el-tab-pane name="users">
					<span slot="label"><i class="el-icon-connection" /> 访问 IP</span>
					<ip-list />
				</el-tab-pane>
				<el-tab-pane name="blacklist">
					<span slot="label"><i class="el-icon-warning-outline" /> 黑名单</span>
					<black-ip-list />
				</el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>

<script>
	import IpList from '@/views/ips/index';
	import BlackIpList from '@/views/ips/black';

	export default {
		name: 'IPOverview',
		components: { IpList, BlackIpList },
		data() {
			return { activeTab: 'users' };
		}
	};
</script>

<style scoped>
	.ip-overview {
		padding-top: 18px;
	}
	.page-hero {
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		height: 96px;
		margin-bottom: 16px;
		padding: 14px 24px;
		color: #fff;
		border-radius: 10px;
		background: linear-gradient(120deg, #276a8d, #3b7d87);
		box-shadow: 0 8px 18px rgba(39, 106, 141, 0.16);
	}
	.eyebrow {
		margin: 0 0 4px;
		color: rgba(255, 255, 255, 0.72);
		font-size: 10px;
		font-weight: 700;
		letter-spacing: 1.4px;
	}
	h2 {
		margin: 0;
		font-size: 20px;
		font-weight: 600;
	}
	.page-hero p:last-child {
		margin: 4px 0 0;
		color: rgba(255, 255, 255, 0.82);
		font-size: 12px;
	}
	.hero-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 44px;
		height: 44px;
		border: 1px solid rgba(255, 255, 255, 0.2);
		border-radius: 12px;
		background: rgba(255, 255, 255, 0.12);
		font-size: 22px;
	}
	.content-card {
		border: 0;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(26, 45, 72, 0.08);
	}
	::v-deep .el-card__body {
		padding: 0 24px 24px;
	}
	::v-deep .ip-tabs > .el-tabs__header {
		margin: 0 -24px 20px;
		padding: 0 24px;
		background: #fafcff;
	}
	::v-deep .ip-tabs .el-tabs__item {
		height: 58px;
		line-height: 58px;
		font-size: 15px;
	}
	@media (max-width: 640px) {
		.page-hero {
			height: auto;
			padding: 20px;
		}
		.hero-icon {
			display: none;
		}
		::v-deep .el-card__body {
			padding: 0 14px 16px;
		}
	}
</style>
